import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Insumo = memo((props: IconProps) => {
    const { color = "#6941C6", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 33 32" fill="none" {...rest}>
            <path
                fill={color}
                d="M19.74 5.325v.173h-5.03v-.173c0-.82.668-1.482 1.483-1.482h2.065c.82 0 1.482.662 1.482 1.482ZM21.566 7.444l-5.602 5.603c-.07.069-.129.138-.193.207h-2.89v-5.78a.99.99 0 0 1 .988-.988h6.709c.533 0 .973.43.988.958ZM28.815 11.036v2.218h-5.014l3.206-3.206h.82a.99.99 0 0 1 .988.988ZM11.79 13.12c-.004.045-.01.09-.02.134H1.763a1.246 1.246 0 0 1-.02-.133c-.237-2.362 1.097-4.259 2.974-4.239.341.005.677.035.998.119.183.044.37.079.558.098V6.368c0-.272.223-.494.494-.494.272 0 .494.222.494.494V7.4c.307-.41.702-.726 1.151-.939a3.13 3.13 0 0 1 2.421-.143A3.17 3.17 0 0 1 7.26 8.393v.706a3.76 3.76 0 0 0 .563-.103 4.4 4.4 0 0 1 .993-.114c1.878-.02 3.211 1.877 2.974 4.239ZM30.9 15.117v3.127c0 .484-.391.874-.875.874H.903a.877.877 0 0 1-.88-.874v-3.127c0-.485.396-.875.88-.875h14.346c-.279.986-.046 2.064.716 2.826a2.848 2.848 0 0 0 4.021 0l2.826-2.826h7.213c.484 0 .874.39.874.875ZM29.038 20.106l-2.762 9.56a2.183 2.183 0 0 1-2.104 1.575H6.752a2.192 2.192 0 0 1-2.104-1.576l-2.761-9.559h27.15Z"
            />
            <path
                fill={color}
                d="M31.728 1.303a1.855 1.855 0 0 0-2.625 0l-12.436 12.44a1.855 1.855 0 0 0 2.62 2.626L31.728 3.928c.716-.705.736-1.9 0-2.625ZM18.055 15.867a.833.833 0 0 1 0-1.665.833.833 0 0 1 0 1.665Z"
            />
        </svg>
    )
})

export default Insumo
